import React, { useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { useSelector } from 'react-redux';
import { FormControlLabel } from '@mui/material';
import FormLabel from '@material-ui/core/FormLabel';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { WrappedFieldProps } from 'redux-form';
import Tooltip from '@mui/material/Tooltip';
import { List } from 'immutable';

import { selectUser } from 'entities/user/selectors';
import Organization from 'entities/organization/model';

const FormSelectedAndOptedInCompanies = ({
  input,
  optedInCompanies,
  sharedWithCompanies,
  meta: { error, dirty },
}: WrappedFieldProps & {
  optedInCompanies: List<Organization>;
  sharedWithCompanies: List<string>;
}) => {
  const user = useSelector(selectUser);

  const siblingSubsidiaries = user?.organization?.siblingSubsidiaries;

  useEffect(() => {
    if (!input.value) {
      input.onChange(sharedWithCompanies || List());
    }
  }, [input, sharedWithCompanies]);

  if (!siblingSubsidiaries) {
    return null;
  }

  const optedInCompaniesIds = optedInCompanies?.map((company) => company.id).filter(Boolean);

  return (
    <div>
      <h4 style={{ marginBottom: 10 }}>Share with other Organizations</h4>
      {siblingSubsidiaries &&
        siblingSubsidiaries.map((subsidiary) => (
          <div key={subsidiary.id}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={sharedWithCompanies.includes(subsidiary.id)}
                  onChange={() => {
                    const updatedSharedWithCompanies = sharedWithCompanies.includes(subsidiary.id)
                      ? sharedWithCompanies.filter((id) => id !== subsidiary.id)
                      : sharedWithCompanies.concat(subsidiary.id);

                    input.onChange(updatedSharedWithCompanies);
                  }}
                />
              }
              label={subsidiary.name}
            />
            {optedInCompaniesIds?.includes(subsidiary.id) && (
              <Tooltip
                title={`${
                  subsidiary.name || 'Organization'
                } has opted in to the deed and shared it with their employees`}
              >
                <TaskAltIcon sx={{ color: '#5128AA' }} />
              </Tooltip>
            )}
          </div>
        ))}
      {error && dirty && (
        <FormLabel error style={{ fontSize: 12, marginTop: 10 }}>
          At least one organization must be selected to share the deed.
        </FormLabel>
      )}
    </div>
  );
};

export default FormSelectedAndOptedInCompanies;
